import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const subscribeUser = async (panelListId) => {
  return securePost("/api/user/subscribe", { panelListId });
};

export const subscribeStatus = async (panelListId) => {
  return secureGet("/api/user/subscribeStatus", { panelListId });
};